import { render, staticRenderFns } from "./ProductExternalDetail.vue?vue&type=template&id=15a331f2&"
import script from "./ProductExternalDetail.vue?vue&type=script&lang=js&"
export * from "./ProductExternalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports